import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-error.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/IRANSansXV.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22}],%22variable%22:%22--font-iranSans%22}],%22variableName%22:%22iranSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'iranSans', 'iranSans Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
